import { TrackingPermissionChecker } from "./TrackingPermissionChecker";

export class CachedTrackingPermissionChecker
	implements TrackingPermissionChecker
{
	private _isTrackingEnabled: boolean | undefined;

	constructor(
		private readonly trackingPermissionChecker: TrackingPermissionChecker
	) {
		// do nothing
	}

	isTrackingEnabled(): boolean {
		this._isTrackingEnabled ??=
			this.trackingPermissionChecker.isTrackingEnabled();
		return this._isTrackingEnabled;
	}
}
